
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function History() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('flights');
  
  const [flightHistory] = useState([
    {
      id: 1,
      flightNumber: 'SV123',
      route: 'الرياض - دبي',
      date: '2024-01-15',
      time: '14:30',
      status: 'مكتملة',
      passengers: 12,
      connections: 3,
      duration: '2س 15د',
      airline: 'الخطوط السعودية'
    },
    {
      id: 2,
      flightNumber: 'MS456',
      route: 'جدة - القاهرة',
      date: '2024-01-10',
      time: '09:45',
      status: 'مكتملة',
      passengers: 8,
      connections: 2,
      duration: '3س 30د',
      airline: 'مصر للطيران'
    },
    {
      id: 3,
      flightNumber: 'EK789',
      route: 'الدمام - لندن',
      date: '2024-01-05',
      time: '22:15',
      status: 'ملغية',
      passengers: 0,
      connections: 0,
      duration: '8س 45د',
      airline: 'طيران الإمارات'
    }
  ]);

  const [connectionHistory] = useState([
    {
      id: 1,
      name: 'سارة أحمد',
      flight: 'SV123',
      date: '2024-01-15',
      type: 'محادثة',
      status: 'نشطة',
      avatar: 'https://public.readdy.ai/ai/img_res/8e0e115f7700ce4225fc4c098cabcc7c.jpg'
    },
    {
      id: 2,
      name: 'محمد علي',
      flight: 'SV123',
      date: '2024-01-15',
      type: 'مشاركة تاكسي',
      status: 'مكتملة',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20man%20in%20business%20attire%2C%20friendly%20confident%20smile%2C%20realistic%20portrait%20photography%2C%20clean%20modern%20background%2C%20natural%20lighting&width=50&height=50&seq=10&orientation=squarish'
    },
    {
      id: 3,
      name: 'فاطمة محمد',
      flight: 'MS456',
      date: '2024-01-10',
      type: 'معلومات الرحلة',
      status: 'مكتملة',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20eastern%20woman%20with%20hijab%2C%20kind%20expression%2C%20realistic%20portrait%20photography%2C%20soft%20lighting%2C%20office%20background%2C%20professional%20attire&width=50&height=50&seq=11&orientation=squarish'
    }
  ]);

  const tabs = [
    { id: 'flights', label: 'الرحلات', icon: 'ri-flight-takeoff-line' },
    { id: 'connections', label: 'الاتصالات', icon: 'ri-group-line' }
  ];

  const getStatusColor = (status: string) => {
    const colors = {
      'مكتملة': 'bg-green-100 text-green-600',
      'ملغية': 'bg-red-100 text-red-600',
      'نشطة': 'bg-blue-100 text-blue-600'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-600';
  };

  const getConnectionIcon = (type: string) => {
    const icons = {
      'محادثة': 'ri-chat-3-line',
      'مشاركة تاكسي': 'ri-taxi-line',
      'معلومات الرحلة': 'ri-information-line'
    };
    return icons[type as keyof typeof icons] || 'ri-user-line';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 pt-12 pb-4 px-6">
        <div className="flex items-center justify-between mb-4">
          <button 
            onClick={() => navigate('/main')}
            className="w-10 h-10 flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-xl text-gray-600"></i>
          </button>
          
          <h1 className="text-lg font-bold text-gray-800 font-arabic">السجل</h1>
          
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-filter-line text-xl text-gray-600"></i>
          </button>
        </div>

        {/* Tabs */}
        <div className="flex space-x-1 space-x-reverse bg-gray-100 rounded-lg p-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 py-2 px-4 rounded-md text-sm font-arabic transition-all duration-200 flex items-center justify-center space-x-2 space-x-reverse ${
                activeTab === tab.id
                  ? 'bg-white text-blue-600 shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              <i className={`${tab.icon} text-base`}></i>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-4">
        {activeTab === 'flights' ? (
          <div className="space-y-4">
            {flightHistory.map((flight) => (
              <div key={flight.id} className="bg-white rounded-2xl p-4 shadow-sm">
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 font-arabic">{flight.flightNumber}</h3>
                    <p className="text-gray-600 text-sm font-arabic">{flight.airline}</p>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-sm font-arabic ${getStatusColor(flight.status)}`}>
                    {flight.status}
                  </span>
                </div>

                <div className="flex items-center space-x-4 space-x-reverse mb-3">
                  <div className="flex items-center space-x-2 space-x-reverse">
                    <i className="ri-map-pin-line text-gray-400"></i>
                    <span className="text-gray-700 font-arabic">{flight.route}</span>
                  </div>
                  <div className="flex items-center space-x-2 space-x-reverse">
                    <i className="ri-time-line text-gray-400"></i>
                    <span className="text-gray-700 font-arabic">{flight.duration}</span>
                  </div>
                </div>

                <div className="flex items-center justify-between text-sm text-gray-600">
                  <div className="flex items-center space-x-4 space-x-reverse">
                    <span className="font-arabic">{flight.date}</span>
                    <span className="font-arabic">{flight.time}</span>
                  </div>
                  <div className="flex items-center space-x-3 space-x-reverse">
                    <span className="font-arabic">{flight.passengers} ركاب</span>
                    <span className="font-arabic">{flight.connections} اتصالات</span>
                  </div>
                </div>

                <button 
                  onClick={() => navigate(`/flight-details/${flight.id}`)}
                  className="w-full mt-3 text-blue-600 text-sm font-arabic hover:text-blue-700"
                >
                  عرض التفاصيل
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div className="space-y-3">
            {connectionHistory.map((connection) => (
              <div key={connection.id} className="bg-white rounded-xl p-4 shadow-sm">
                <div className="flex items-center space-x-3 space-x-reverse">
                  <img 
                    src={connection.avatar} 
                    alt={connection.name} 
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-1">
                      <h3 className="font-bold text-gray-800 font-arabic">{connection.name}</h3>
                      <span className={`px-2 py-1 rounded-full text-xs font-arabic ${getStatusColor(connection.status)}`}>
                        {connection.status}
                      </span>
                    </div>
                    
                    <div className="flex items-center space-x-3 space-x-reverse text-sm text-gray-600">
                      <div className="flex items-center space-x-1 space-x-reverse">
                        <i className={`${getConnectionIcon(connection.type)} text-gray-400`}></i>
                        <span className="font-arabic">{connection.type}</span>
                      </div>
                      <span className="font-arabic">{connection.flight}</span>
                      <span className="font-arabic">{connection.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Statistics */}
        <div className="mt-8 mb-20">
          <h2 className="text-lg font-bold text-gray-800 mb-4 font-arabic">الإحصائيات</h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white rounded-xl p-4 text-center shadow-sm">
              <div className="text-2xl font-bold text-blue-600 mb-1">
                {flightHistory.filter(f => f.status === 'مكتملة').length}
              </div>
              <div className="text-sm text-gray-600 font-arabic">رحلات مكتملة</div>
            </div>
            <div className="bg-white rounded-xl p-4 text-center shadow-sm">
              <div className="text-2xl font-bold text-green-600 mb-1">
                {connectionHistory.length}
              </div>
              <div className="text-sm text-gray-600 font-arabic">إجمالي الاتصالات</div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}